/**
 * VMA level badges and the days-listed caption, shared by the Client and Broker
 * VIN pop-outs. Extracted from the Client pop-out when the Broker one adopted
 * the same treatment (§6.3). Tone maps live in ./vmaLevelTones.
 */
import React from 'react';
import type { LevelTone } from './vmaLevelTones';
import './VmaLevels.css';

const fmtStr = (v?: string | null): string => (v && String(v).trim()) || '–';
const fmtInt = (v?: number | null): string =>
  v == null ? '–' : Math.round(v).toLocaleString();

export const LevelBadge: React.FC<{
  label: string;
  level?: string | null;
  tones: Record<string, LevelTone>;
  hint?: string;
}> = ({ label, level, tones, hint }) => {
  const tone = level ? tones[level.trim().toLowerCase()] ?? 'neutral' : 'none';
  return (
    <div className="vin-level" title={hint}>
      <span className="vin-level-label">{label}</span>
      <span className={`vin-level-badge vin-level-badge--${tone}`}>{fmtStr(level)}</span>
    </div>
  );
};

/** Days listed read against how fast the model actually turns, not in isolation. */
export const VelocityCaption: React.FC<{
  daysListed?: number | null;
  avgDaysToSell?: number | null;
}> = ({ daysListed, avgDaysToSell }) => {
  if (daysListed == null || avgDaysToSell == null || avgDaysToSell <= 0) return null;
  const over = daysListed > avgDaysToSell;
  return (
    <p className={`vin-velocity-caption${over ? ' vin-velocity-caption--over' : ''}`}>
      {over
        ? `Listed ${fmtInt(daysListed)} days — past the ${fmtInt(avgDaysToSell)}-day wholesale average for this model.`
        : `Listed ${fmtInt(daysListed)} of the ${fmtInt(avgDaysToSell)} days this model averages to sell at wholesale.`}
    </p>
  );
};
